import Styled from 'styled-components';

const FileIconContainer = Styled.div`
  height: ${props => props.height};
  width: ${props => props.width};
  display: flex;
`;

export { FileIconContainer };
